import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

const Settings: React.FC = () => {
  return (
    <StyledContainer maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Indstillinger
      </Typography>
      <StyledPaper>
        <Typography variant="body1">
          Indstillinger vil blive tilføjet her.
        </Typography>
      </StyledPaper>
    </StyledContainer>
  );
};

export default Settings; 